module.exports = __webpack_public_path__ + "img/font_legerd.d121875.svg";